// Module
var code = "<div class=\"level-left\"> <div class=\"level-item\"> <label class=\"label\"> Other options: </label> </div> <div id=\"decimalsButtons\" class=\"level-item buttons\"></div> </div> ";
// Exports
export default code;